import { useTranslation } from 'react-i18next';
import { isCp, setDesign, DESIGN_CLASSIC, DESIGN_CP } from 'libs/design';
import { Switch, Option } from './design-switch.styled';

/**
 * Переключатель дизайна «Новый / Классический» в шапке (одинаковый вид в обоих дизайнах)
 */
export const DesignSwitch = () => {
  const { t } = useTranslation();

  const choose = (value) => {
    if ((value === DESIGN_CP) !== isCp) {
      setDesign(value);
    }
  };

  return (
    <Switch>
      <Option type="button" className={isCp ? 'active' : ''} onClick={() => choose(DESIGN_CP)}>
        {t('dock.Новый')}
      </Option>
      <Option type="button" className={isCp ? '' : 'active'} onClick={() => choose(DESIGN_CLASSIC)}>
        {t('dock.Классический')}
      </Option>
    </Switch>
  );
};
